// Version : 0.0.3
// Author : AGALYA
// LastEdit : SHIYAM
// Last ADD : changed single line const function for payload in all function
// MODFIED DATE : 07-08-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';
import PurposeOfLoanActionTypes from './purpose-of-loan.types';
import {
	purposeofLoanDetailsAdd,
	purposeofLoanDetailsUpdate,
	purposeofLoanListGet,
	purposeofLoanDetailsFetch,
	purposeofLoanDetailsDelete,
	purposeOfLoanIsPublishUpdate,
} from './purpose-of-loan.service';
import {
	addPurposeOfLoanDetailsSuccess,
	addPurposeOfLoanDetailsFailure,
	addPurposeOfLoanDetailsResponseChanged,
	updatePurposeOfLoanDetailsSuccess,
	updatePurposeOfLoanDetailsFailure,
	updatePurposeOfLoanDetailsResponseChanged,
	getPurposeOfLoanListSuccess,
	getPurposeOfLoanListFailure,
	getPurposeOfLoanListResponseChanged,
	fetchPurposeOfLoanDetailsSuccess,
	fetchPurposeOfLoanDetailsFailure,
	fetchPurposeOfLoanDetailsResponseChanged,
	deletePurposeOfLoanDetailsSuccess,
	deletePurposeOfLoanDetailsFailure,
	deletePurposeOfLoanDetailsResponseChanged,
	updatePurposeOfLoanPublishStatusSuccess,
	updatePurposeOfLoanPublishStatusFailure,
	updatePurposeOfLoanPublishStatusResponseChanged,
} from './purpose-of-loan.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START ADD PURPOSE OF LOAN DETAILS  ******************** */
export function* createPurposeOfLoan({ payload }: any) {
	try {
		const {
			purposeOfLoanName,
			purposeOfLoanCategoryID,
			companyID,
			userID,
			userName,
			userAccessBranchID,
			databaseName,
		} = payload;
		const key = 'AddPurposeOfLoanDetailKey';
		const jsonData = {
			PurposeOfLoanName: purposeOfLoanName,
			PurposeOfLoanCategoryID: purposeOfLoanCategoryID,
			CompanyID: companyID,
			CreatedBy: userID,
			UserName: userName,
			UserAccessBranchID: userAccessBranchID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(purposeofLoanDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addPurposeOfLoanDetailsFailure(responseData.data));
		} else {
			yield put(addPurposeOfLoanDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addPurposeOfLoanDetailsFailure(error));
	}
}
export function* resetAddPurposeOfLoanResponse() {
	yield put(addPurposeOfLoanDetailsResponseChanged());
}
export function* onCreatePurposeOfLoanDetails() {
	yield takeLatest(
		PurposeOfLoanActionTypes.ADD_PURPOSE_OF_LOAN_DETAILS_START,
		createPurposeOfLoan,
	);
}
export function* onCreatePurposeOfLoanResponseReset() {
	yield takeLatest(
		PurposeOfLoanActionTypes.ADD_PURPOSE_OF_LOAN_DETAILS_RESPONSE_RESET,
		resetAddPurposeOfLoanResponse,
	);
}
/** *********************  END ADD PURPOSE OF LOAN DETAILS ******************** */

/** *********************  START UPDATE PURPOSE OF LOAN DETAILS  ******************** */
export function* purposeofLoanUpdate({ payload }: any) {
	try {
		const {
			purposeOfLoanID,
			purposeOfLoanName,
			purposeOfLoanCategoryID,
			companyID,
			userID,
			userName,
			userAccessBranchID,
			databaseName,
		} = payload;
		const key = 'UpdatePurposeOfLoanDetailsKey';
		const jsonData = {
			PurposeOfLoanID: purposeOfLoanID,
			PurposeOfLoanName: purposeOfLoanName,
			PurposeOfLoanCategoryID: purposeOfLoanCategoryID,
			CompanyID: companyID,
			UserID: userID,
			UserName: userName,
			UserAccessBranchID: userAccessBranchID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(purposeofLoanDetailsUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updatePurposeOfLoanDetailsFailure(responseData.data));
		} else {
			yield put(updatePurposeOfLoanDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updatePurposeOfLoanDetailsFailure(error));
	}
}
export function* resetUpdatePurposeOfLoanDetailsResponse() {
	yield put(updatePurposeOfLoanDetailsResponseChanged());
}
export function* onUpdatePurposeOfLoanDetails() {
	yield takeLatest(
		PurposeOfLoanActionTypes.UPDATE_PURPOSE_OF_LOAN_DETAILS_START,
		purposeofLoanUpdate,
	);
}
export function* onUpdatePurposeOfLoanResponseReset() {
	yield takeLatest(
		PurposeOfLoanActionTypes.UPDATE_PURPOSE_OF_LOAN_DETAILS_RESPONSE_RESET,
		resetUpdatePurposeOfLoanDetailsResponse,
	);
}
/** *********************  END UPDATE PURPOSE OF LOAN DETAILS ******************** */

/** *********************  START GET PURPOSE OF LOAN LIST  ******************** */
export function* purposeofLoanDetailsListGet({ payload }: any) {
	try {
		const { companyID, inputSearch, limit, databaseName } = payload;
		const key = 'GetPurposeOfLoanListKey';
		const jsonData = {
			CompanyID: companyID,
			InputSearch: inputSearch,
			Limit: limit,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(purposeofLoanListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getPurposeOfLoanListFailure(responseData.data));
		} else {
			yield put(getPurposeOfLoanListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getPurposeOfLoanListFailure(error));
	}
}
export function* resetGetPurposeOfLoanListResponse() {
	yield put(getPurposeOfLoanListResponseChanged());
}
export function* onGetPurposeOfLoanListDetails() {
	yield takeLatest(
		PurposeOfLoanActionTypes.GET_PURPOSE_OF_LOAN_LIST_START,
		purposeofLoanDetailsListGet,
	);
}
export function* onGetPurposeOfLoanListResponseReset() {
	yield takeLatest(
		PurposeOfLoanActionTypes.GET_PURPOSE_OF_LOAN_LIST_RESPONSE_RESET,
		resetGetPurposeOfLoanListResponse,
	);
}
/** *********************  END GET PURPOSE OF LOAN LIST ******************** */

/** *********************  START FETCH PURPOSE OF LOAN DETAILS  ******************** */
export function* fetchPurposeOfLoanData({ payload }: any) {
	try {
		const { companyID, purposeOfLoanID, databaseName } = payload;
		const key = 'FetchPurposeOfLoanDetailsKey';
		const jsonData = {
			CompanyID: companyID,
			PurposeOfLoanID: purposeOfLoanID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(purposeofLoanDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchPurposeOfLoanDetailsFailure(responseData.data));
		} else {
			yield put(fetchPurposeOfLoanDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchPurposeOfLoanDetailsFailure(error));
	}
}
export function* resetFetchPurposeOfLoanDetailsResponse() {
	yield put(fetchPurposeOfLoanDetailsResponseChanged());
}
export function* onFetchPurposeOfLoanDetails() {
	yield takeLatest(
		PurposeOfLoanActionTypes.FETCH_PURPOSE_OF_LOAN_DETAILS_START,
		fetchPurposeOfLoanData,
	);
}
export function* onFetchPurposeOfLoanResponseReset() {
	yield takeLatest(
		PurposeOfLoanActionTypes.FETCH_PURPOSE_OF_LOAN_DETAILS_RESPONSE_RESET,
		resetFetchPurposeOfLoanDetailsResponse,
	);
}
/** *********************  END FETCH PURPOSE OF LOAN DETAILS ******************** */

/** *********************  START DELETE PURPOSE OF LOAN DETAILS  ******************** */
export function* purposeofLoanDelete({ payload }: any) {
	try {
		const {
			companyID,
			purposeOfLoanID,
			purposeOfLoanName,
			databaseName,
			userName,
			userID,
			userAccessBranchID,
		} = payload;
		const key = 'DeletePurposeOfLoanDetailsKey';
		const jsonData = {
			CompanyID: companyID,
			PurposeOfLoanID: purposeOfLoanID,
			PurposeOfLoanName: purposeOfLoanName,
			DatabaseName: databaseName,
			UserName: userName,
			DeletedBy: userID,
			UserAccessBranchID: userAccessBranchID,
			IsActive: '0',
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(purposeofLoanDetailsDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deletePurposeOfLoanDetailsFailure(responseData.data));
		} else {
			yield put(deletePurposeOfLoanDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deletePurposeOfLoanDetailsFailure(error));
	}
}
export function* resetDeletePurposeOfLoanDetailsResponse() {
	yield put(deletePurposeOfLoanDetailsResponseChanged());
}
export function* onDeletePurposeOfLoanDetail() {
	yield takeLatest(
		PurposeOfLoanActionTypes.DELETE_PURPOSE_OF_LOAN_DETAILS_START,
		purposeofLoanDelete,
	);
}
export function* onDeletePurposeOfLoanResponseReset() {
	yield takeLatest(
		PurposeOfLoanActionTypes.DELETE_PURPOSE_OF_LOAN_DETAILS_RESPONSE_RESET,
		resetDeletePurposeOfLoanDetailsResponse,
	);
}
/** *********************  END DELETE PURPOSE OF LOAN DETAILS ******************** */

/** *********************  START UPDATE PURPOSE OF LOAN PUBLISH STATUS  ******************** */
export function* purposeofLoanPublishStatusUpdate({ payload }: any) {
	try {
		const {
			purposeOfLoanID,
			purposeOfLoanName,
			isPublish,
			companyID,
			userID,
			userName,
			userAccessBranchID,
			databaseName,
		} = payload;
		const key = 'UpdatePurposeOfLoanPublishStatusKey';
		const jsonData = {
			PurposeOfLoanID: purposeOfLoanID,
			PurposeOfLoanName: purposeOfLoanName,
			IsPublish: isPublish,
			CompanyID: companyID,
			UserID: userID,
			UserName: userName,
			UserAccessBranchID: userAccessBranchID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(purposeOfLoanIsPublishUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updatePurposeOfLoanPublishStatusFailure(responseData.data));
		} else {
			yield put(updatePurposeOfLoanPublishStatusSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updatePurposeOfLoanPublishStatusFailure(error));
	}
}
export function* resetUpdatePurposeOfLoanPublishStatusResponse() {
	yield put(updatePurposeOfLoanPublishStatusResponseChanged());
}
export function* onUpdatePurposeOfLoanPublishStatus() {
	yield takeLatest(
		PurposeOfLoanActionTypes.UPDATE_PURPOSE_OF_LOAN_PUBLISH_STATUS_START,
		purposeofLoanPublishStatusUpdate,
	);
}
export function* onUpdatePurposeOfLoanPublishStatusResponseReset() {
	yield takeLatest(
		PurposeOfLoanActionTypes.UPDATE_PURPOSE_OF_LOAN_PUBLISH_STATUS_RESPONSE_RESET,
		resetUpdatePurposeOfLoanPublishStatusResponse,
	);
}
/** *********************  END UPDATE PURPOSE OF LOAN PUBLISH STATUS ******************** */

export function* purposeofLoanSaga() {
	yield all([
		call(onCreatePurposeOfLoanDetails),
		call(onCreatePurposeOfLoanResponseReset),
		call(onUpdatePurposeOfLoanDetails),
		call(onUpdatePurposeOfLoanResponseReset),
		call(onGetPurposeOfLoanListDetails),
		call(onGetPurposeOfLoanListResponseReset),
		call(onFetchPurposeOfLoanDetails),
		call(onFetchPurposeOfLoanResponseReset),
		call(onDeletePurposeOfLoanDetail),
		call(onDeletePurposeOfLoanResponseReset),
		call(onUpdatePurposeOfLoanPublishStatus),
		call(onUpdatePurposeOfLoanPublishStatusResponseReset),
	]);
}
